export const TABLE_SETTING = {
	DEFAULT_PAGE_SIZE: 25,
	ROWS_PER_PAGE_OPTIONS: [25, 50, 100],
};
